<template lang="pug">
  form.modal-card(v-on:submit.prevent="submitForm()")
    header.modal-card-head
      p.modal-card-title Redefinir Senha
    section.modal-card-body
      p Digite abaixo uma nova senha para a sua conta. Após salvar você poderá autenticar normalmente com sua nova senha.
      hr
      b-field(label="Senha*" v-bind:message="errors.first('senha')" v-bind:type="isDanger('senha')")
        b-input(type="password" placeholder="Digite sua nova senha" v-model="user.password" v-validate="validations.password" name="senha" password-reveal ref="senha")

      b-field(label="Confirmar Senha*" v-bind:message="errors.first('confirm')" v-bind:type="isDanger('confirm')")
        b-input(type="password" placeholder="Repita sua nova senha" v-model="user.confirm" v-validate="validations.confirm" name="confirm" data-vv-as="confirmação de senha" password-reveal)
      b-field.has-text-centered
    footer.modal-card-foot
      button.button.is-primary(v-bind:disabled="formInvalid" type="submit") Salvar
      a.button.is-danger.is-outlined(@click="$parent.close()") Fechar
</template>

<script>
  import AuthService from '@/services/auth.js'

  export default {
    name: 'resetPasswordModal',
    data () {
      return {
        user: {password: '', confirm: ''},
        validations: {
          password: {rules: {required: true, min: 5, max: 20}},
          confirm: {rules: {required: true, confirmed: 'senha'}}
        }
      }
    },
    props: ['token'],
    methods: {
      isDanger (fieldName) {
        if (this.$validator.errors.has(fieldName)) return 'is-danger'
      },
      submitForm () {
        const loadingComponent = this.$loading.open()
        AuthService.updatePassword(this.token, this.user.password)
        .then(response => {
          this.$snackbar.open({
            message: 'Senha redefinida com sucesso!',
            position: 'is-top'
          })
          loadingComponent.close()
          this.$parent.close()
        }, response => {
          loadingComponent.close()
          let errorMessage = (response.status === 404) ? 'Token inválido! Solicite novamente a redefinição da senha.' : 'Erro ao redefinir a senha!'
          this.$snackbar.open({
            message: errorMessage,
            type: 'is-danger',
            actionText: 'Ver Erro',
            onAction: () => {
              this.$modal.open({content: `<pre>${JSON.stringify(response.body)}</pre>`})
            },
            position: 'is-top'
          })
        })
      }
    },
    computed: {
      formInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid || !this.fields[key].validated)
      }
    }
  }
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// ResetPasswordModal.vue?a2479794